<script>
import messages from '../mixins/messages'
import TermsOfServiceLink from './TermsOfServiceLink.vue'
import PaymentMethod from '../components/PaymentMethod.vue'
import { UserVoucherResource } from '../resources/voucher'

export default {
    name: 'VoucherPitch',
    mixins: [messages],
    components: {
        TermsOfServiceLink,
        PaymentMethod
    },
    computed: {
        amountCents() {
            let userValue = parseInt(this.amountDollars)

            if (!userValue) {
                return 1e4
            }

            return userValue * 100
        },
    },
    watch: {
        userResource() {
            this.emailToFromName = this.userResource.fullName()
        }
    },
    data() {
        return {
            loading: true,
            amountDollars: 100,
            emailTo: false,
            emailToEmail: '',
            emailToFromName: '',
            emailToComments: '',
            userCardDetails: {},
            userResource: null,
            voucherResource: null,
            showSuccess: false
        }
    },
    methods: {
        async onSubmit() {
            try {
                this.loading = true
                const extraData = !this.emailTo ? undefined : {
                    emailTo: this.emailToEmail,
                    emailFromName: this.emailToFromName,
                    emailComments: this.emailToComments
                }

                this.voucherResource = await UserVoucherResource.purchaseGiftCard(this.amountCents, extraData)
                this.showSuccess = true
                this.$emit('success', this.voucherResource)
            } catch(e) {
                throw this.axiosExtract(e)
            } finally {
                this.loading = false
            }
        },
        async onCardAdded() {
            this.userCardDetails = await this.userResource.getCard()
        },
        onSuccess() {
            this.$emit('done')
        },
        onClose() {
            this.$emit('close')
        }
    },
    async mounted() {
        this.userResource = await this.$store.dispatch('getUserResource')
        this.userCardDetails = await this.userResource.getCard()
        this.loading = false
    }
}
</script>

<template>
    <div class="voucher-pitch">
        <b-row v-if="!loading && !showSuccess">
            <b-col>
                <b-form @submit.prevent="onSubmit">
                    <b-form-group label="Value of Gift Voucher" label-cols-md="6">
                        <b-input-group :prepend="currencySymbol()" append=".00">
                            <b-form-input type="number" v-model="amountDollars"></b-form-input>
                        </b-input-group>
                    </b-form-group>

                    <hr />

                    <p><strong>A voucher code will be emailed to you.</strong> This voucher code can be used for booking reservations for any simulator type at any date/time.</p>
                    
                    <p><b-form-checkbox v-model="emailTo">Email this voucher code to someone special</b-form-checkbox></p>

                    <div v-if="emailTo">
                        <b-form-group label="Email Address of Recipient">
                            <b-form-input type="email" v-model="emailToEmail" placeholder="Email Address"  :required="emailTo"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Your Name">
                            <b-form-input v-model="emailToFromName" placeholder="Your Name" :required="emailTo"></b-form-input>
                        </b-form-group>

                        <b-form-group label="Additional Comments" description="Maximum 200 characters">
                            <b-form-textarea v-model="emailToComments" placeholder="Eg. 'Happy Birthday!'" maxlength="200"></b-form-textarea>
                        </b-form-group>
                    </div>
                    
                    <div v-if="!Object.keys(userCardDetails).length">
                        <hr />
                        <payment-method cols-lg="12" :user-resource="userResource" @success="onCardAdded">
                            <b-alert variant="success" show><b-icon icon="lock-fill" /> Your card will not be charged yet</b-alert>
                        </payment-method>
                    </div>
                    
                    <div v-else>
                        <b-alert variant="info" show>Your <strong>{{ userCardDetails.brand }} ending in {{ userCardDetails.last4 }}</strong> will be charged {{ currencySymbol() }}{{ moneyFormat(amountCents) }}.</b-alert>
                        <small class="text-muted"><terms-of-service-link /></small>
                        <messages class="mt-3" />
                        <b-button type="submit" class="col-sm-12 mt-3" :disabled="loading">Purchase Gift Voucher</b-button>
                    </div>
                </b-form>
            </b-col>
        </b-row>

        <div v-else-if="showSuccess">
            <b-alert variant="success" show><strong>Success! Your gift voucher has been purchased!</strong> <span v-if="emailTo">This gift voucher has also been sent to <strong>{{ emailToEmail }}</strong></span></b-alert>
            <p>Please write down the code below. Entering this code during checkout will apply the balance of this voucher to your checkout cost.</p>
            <b-card header="Voucher Code">
                <h4 class="text-center mb-0">
                    {{ voucherResource }}
                </h4>
            </b-card>
            <b-button variant="primary" class="col-sm-12 mt-3" @click="onSuccess">All Done</b-button>
        </div>

        <div v-else>
            <b-skeleton-wrapper>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <b-skeleton width="70%"></b-skeleton>
            </b-skeleton-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
</style>
